import { render, staticRenderFns } from "./ConventionCompactInfoAnnotation.vue?vue&type=template&id=8eda30c2"
import script from "./ConventionCompactInfoAnnotation.vue?vue&type=script&lang=js"
export * from "./ConventionCompactInfoAnnotation.vue?vue&type=script&lang=js"
import style0 from "./ConventionCompactInfoAnnotation.vue?vue&type=style&index=0&id=8eda30c2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports